export function Debounce(delay: number = 300): MethodDecorator {
  // @ts-ignore
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    const timeoutKey = Symbol();

    const original = descriptor.value;

    // tslint:disable-next-line:typedef
    descriptor.value = function (...args: any) {
      // @ts-ignore
      clearTimeout(this[timeoutKey]);
      // @ts-ignore
      this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}
